import { UserInputError } from "./errors-CEDWDXew.js";
import { isNumericId } from "./slug-validation-MJ3jU0Hd.js";

//#region src/internal/url-scope.ts
function resolveScopedOrganizationSlug({ resourceLabel, scopedOrganizationSlug, urlOrganizationSlug }) {
	if (!scopedOrganizationSlug) return urlOrganizationSlug;
	if (scopedOrganizationSlug !== urlOrganizationSlug) throw new UserInputError(`${resourceLabel} URL is outside the active organization constraint. Expected organization "${scopedOrganizationSlug}" but got "${urlOrganizationSlug}".`);
	return scopedOrganizationSlug;
}
function resolveScopedProjectSlug({ resourceLabel, scopedProjectSlug, urlProjectSlug }) {
	if (!scopedProjectSlug) return urlProjectSlug;
	if (scopedProjectSlug !== urlProjectSlug) throw new UserInputError(`${resourceLabel} URL is outside the active project constraint. Expected project "${scopedProjectSlug}" but got "${urlProjectSlug}".`);
	return scopedProjectSlug;
}
function assertScopedProjectSlug({ resourceLabel, scopedProjectSlug, actualProjectSlug }) {
	if (!scopedProjectSlug) return actualProjectSlug;
	if (scopedProjectSlug !== actualProjectSlug) throw new UserInputError(`${resourceLabel} is outside the active project constraint. Expected project "${scopedProjectSlug}".`);
	return actualProjectSlug;
}
function resolveScopedProjectSlugOrId({ resourceLabel, scopedProjectSlugOrId, urlProjectSlug }) {
	if (scopedProjectSlugOrId == null || typeof scopedProjectSlugOrId === "string" && scopedProjectSlugOrId.trim() === "") return urlProjectSlug;
	if (typeof scopedProjectSlugOrId === "number" || isNumericId(String(scopedProjectSlugOrId))) return urlProjectSlug;
	if (scopedProjectSlugOrId !== urlProjectSlug) throw new UserInputError(`${resourceLabel} URL is outside the active project constraint. Expected project "${scopedProjectSlugOrId}" but got "${urlProjectSlug}".`);
	return scopedProjectSlugOrId;
}

//#endregion
export { assertScopedProjectSlug, resolveScopedOrganizationSlug, resolveScopedProjectSlug, resolveScopedProjectSlugOrId };
//# sourceMappingURL=url-scope-CRM5sNo7.js.map